import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";

import client from "./client";
import consentDateTime from "./consent-date";
import create from "./create";
import dataReport from "./data-report";
import gdpr from "./gdpr";
import intl from "./intl";
import merge from "./merge";
import navigation from "./navigation";
import password from "./password";
import personalUser from "./personal-user";
import secretQuestions from "./secret-questions";

export default history => {
  return combineReducers({
    client,
    consentDateTime,
    router: connectRouter(history),
    intl,
    personalUser,
    secretQuestions,
    navigation,
    create,
    gdpr,
    dataReport,
    merge,
    password,
    paths(state = {}) {
      return state;
    },
    ipAddress(state = {}) {
      return state;
    }
  });
};
